import React from 'react'
import './header.css'
import gmail from '../../img/gmail.svg'

function Header() {
   return (
      <header className='header'>
         <div className="container">
            <nav className='nav'>
               <span className="header__span">Контакты</span>
               <a target="_blank" rel="noreferrer" href="https://telete.in/Rozhkova_Ekaterina" className="header__link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" fill="none"><path d="M21.918 2.474l-3.31 15.63c-.229 1.108-.898 1.374-1.833.861l-5.042-3.73-2.438 2.355c-.275.275-.504.513-1.008.513-.66 0-.55-.247-.77-.87l-1.742-5.675L.779 10c-1.081-.32-1.09-1.063.239-1.604L20.506.879c.889-.394 1.741.22 1.402 1.586l.01.01z" fill="#262626" /></svg>
               </a>
               <a target="_blank" rel="noreferrer" href="https://github.com/ekaterina-create" className="header__link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none"><path d="M11 .272c-6.077 0-11 4.925-11 11 0 4.861 3.151 8.984 7.521 10.437.55.103.752-.237.752-.53 0-.26-.01-.953-.014-1.87-3.06.664-3.705-1.475-3.705-1.475-.5-1.27-1.224-1.609-1.224-1.609-.996-.682.077-.668.077-.668 1.105.077 1.685 1.133 1.685 1.133.98 1.682 2.575 1.196 3.204.915.099-.712.382-1.197.697-1.472-2.443-.275-5.011-1.22-5.011-5.435 0-1.201.426-2.182 1.132-2.952-.124-.278-.495-1.396.096-2.912 0 0 .922-.295 3.025 1.128.88-.245 1.815-.366 2.75-.371.935.005 1.87.126 2.75.371 2.09-1.423 3.012-1.128 3.012-1.128.59 1.516.22 2.634.11 2.912.7.77 1.127 1.75 1.127 2.951 0 4.226-2.571 5.157-5.019 5.427.385.33.743 1.005.743 2.035 0 1.472-.014 2.655-.014 3.012 0 .29.193.633.756.523A10.962 10.962 0 0022 11.272c0-6.075-4.925-11-11-11z" fill="#262626" /></svg></a>
               <a href="mailto:abashkina.k@gmail.com" className="header__link" rel="noreferrer">
                  <img src={gmail} alt="Gmail" />
               </a>
            </nav>
            <div className='header__content'>
               <h1 className="title">Привет, я Екатерина Рожкова</h1>
               <p className='header__text'>Изучаю Веб-Разработку около года, ищу стажировку или Junior позицию.</p>
               <p className='header__text'>Стек технологий: HTML, СSS, SCSS, GULP, GIT, WebPack, Linux -уровень пользователя, ES6, React и TypeScript(изучаю).</p>
               <p className='header__text'>Имею сильную мотивацию на получение всех необходимых для работы навыков. </p>
               <a href="https://docs.google.com/document/d/1SGMZMt28QLL3MtvX-tZPeeiuRBl983c_/edit">Ссылка на мое резюме</a>
               <a href="https://github.com/ekaterina-create">Ссылка на GitHub</a>
               <h2>ПРОЕКТЫ</h2>
            </div>

         </div>
      </header>
   )
}

export default Header
